import { useState, useRef, useEffect, useMemo } from "react"

/* ================= BASE STYLES ================= */

const baseContainerStyle = {
  position: "relative"
}

const baseTriggerStyle = {
  width: "260px",
  height: "40px",
  backgroundColor: "rgba(0, 0, 0, 0.08)",
  borderRadius: "5px",
  display: "flex",
  alignItems: "center",
  padding: "5px",
  justifyContent: "space-between",
  fontSize: "14px",
  fontWeight: "bold",
  cursor: "pointer"
}

const baseMenuStyle = {
  position: "absolute",
  width: "260px",
  height: "max-content",
  display: "flex",
  flexDirection: "column",
  gap: "0px",
  padding: "5px",
  backgroundColor: "#ffffff",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)",
  overflowY: "auto",
  zIndex: 10000
}

const baseOptionStyle = {
  padding: "8px 14px",
  cursor: "pointer",
  fontSize: "14px",
  transition: "background 0.3s ease",
  textAlign: "center",
  fontWeight: "400"
}

const baseHoverStyle = {
  color: "balck",
  fontSize:"16px",
  border:"1px solid var(--selecte-row-color)",
  backgroundColor:"var(--even-row-hover)",
  fontWeight:"bold"
}

const baseEvenRow = {
  backgroundColor: "var(--grid-even-color)"
}

const baseOddRow = {
  backgroundColor: "var(--grid-odd-color)"
}

const baseSelectedRow = {
  backgroundColor: "var(--selecte-row-color)"
}

/* ================= COMPONENT ================= */

const DropDown = ({
  options = [],
  value = null,
  onChange,
  placeholder = "Select option",
  direction = "down",

  // styles
  containerStyle = {},
  triggerStyle = {},
  menuStyle = {},
  optionStyle = {},
  hoverStyle = {},
  selectedStyle = {},
  evenRowStyle = {},
  oddRowStyle = {}
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const [highlightIndex, setHighlightIndex] = useState(-1)
  const wrapperRef = useRef(null)

  const selected = useMemo(() => {
    return options.find(opt => opt.id === value?.id)
  }, [options, value])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => document.removeEventListener("mousedown", handleClickOutside)
  }, [])

  const handleSelect = (item) => {
    onChange && onChange(item)
    setIsOpen(false)
  }

  const directionStyle =
  direction === "up"
    ? { bottom: "45px", left: 0 }  // render above trigger
    : { top: "45px", left: 0 }     // render below trigger

  return (
    <div
      ref={wrapperRef}
      style={{ ...baseContainerStyle, ...containerStyle }}
    >
      {/* Trigger */}
      <div
        onClick={() => setIsOpen(prev => !prev)}
        style={{ ...baseTriggerStyle, ...triggerStyle }}
      >
        <span>
          {selected ? selected.title : placeholder}
        </span>
         <span 
                className= {  isOpen ? "k-icon k-i-arrow-chevron-up"  : "k-icon k-i-arrow-chevron-down"}
                style={{cursor:"pointer"}}
                ></span>
      </div>

      {/* Menu */}
      {isOpen && (
        <div style={{ ...baseMenuStyle, ...directionStyle,...menuStyle }}>
          {options.map((item, index) => {

            const isSelected = value?.id === item.id
            const isHovered = highlightIndex === index

            let finalStyle = {
              ...baseOptionStyle,
              ...((index + 1) % 2 === 0 ? baseEvenRow : baseOddRow),
              ...(isHovered ? baseHoverStyle : {}),
               ...(isSelected ? baseSelectedRow : {}),
            }

        
            finalStyle = {
              ...finalStyle,
              ...optionStyle,
              ...(index % 2 === 0 ? evenRowStyle : oddRowStyle),
              ...(isHovered ? hoverStyle : {}),
              ...(isSelected ? selectedStyle : {}),
            }

            return (
              <div
                key={item.id}
                style={finalStyle}
                onClick={() => handleSelect(item)}
                onMouseEnter={() => setHighlightIndex(index)}
                onMouseLeave={() => setHighlightIndex(-1)}
              >
                {item.customCell
                  ? item.customCell(item)
                  : item.title}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default DropDown

